export default {
  // List
  List: {
    Title: 'Nộp báo cáo lên cấp trên',
    MenuItem: {
      NotificationDetail: 'Chi tiết thông báo',
      NoticeFromSuperior: 'Thông báo từ cấp trên',
    },
    GridColumns: {
      ViewReport: 'Xem báo cáo',
    },
  },
  // General detail
  Detail: {
    Title: 'Nộp báo cáo lên cấp trên',
  },
  // First step
  StepOne: {
    GridColumns: {
      ReportGroup: 'Nhóm báo cáo',
      ReportName: 'Tên báo cáo',
    },
    GridTitle: 'Chọn báo cáo cần nộp',
  },
  // Second step
  StepTwo: {
    GridColumns: {
      BudgetSourceCode: 'Mã nguồn',
      BudgetSourceName: 'Tên nguồn',
    },
    GridTitle: {
      BudgetSourceUnit: 'Danh mục nguồn tại đơn vị',
      BudgetSourceSuperiorUnit: 'Danh mục nguồn của đơn vị cấp trên',
    },
  },
  // Third step
  StepThree: {
    GridTitle: 'Danh sách báo cáo đã chọn',
    Input: {
      Placeholder: 'Nhập thông tin ghi chú của tài liệu',
    },
  },
  // Notification detail popup
  NotificationDetail: {
    GridColumns: {
      NumericalOrder: 'STT',
      NotificationContent: 'Thông báo',
      NotificationDetail: 'Chi tiết thông báo',
      Time: 'Thời gian',
    },
  },

  Lekima: {
    MisaLekima: 'MISA Lekima',
    Connect: 'Kết nối',
    InforLogin: 'Nộp hồ sơ trực tiếp cho đơn vị cấp trên',
    Username: 'Tên đăng nhập',
    Password: 'Mật khẩu',
    Note: 'Nếu chưa đăng ký với đơn vị cấp trên. Vui lòng anh/chị đăng ký ',
    Here: 'tại đây',
    Feature: 'Với nhiều tính năng ưu việt',
    StepOne: 'Nộp báo cáo trực tiếp cho cấp trên',
    StepTwo: 'Tức thời nhận kết quả phê duyệt',
    NoReport: 'Bạn chưa nộp báo cáo nào',
    Submit: 'Nộp báo cáo'
  }
};
